import { callApi } from "repoV2/utils/common/api/callApi";
import { CALL_API_METHODS } from "repoV2/constants/apis";
import { listing_apis } from "../Listing.constants";
import { IGetMerchandiseVariantsApiResponseData } from "../Listing.interfaces";

export const callGetMerchandiseVariantsApi = async ({
    listingUuid,
    isHidePurchaseDetails,
    isCheckout,
}: {
    listingUuid: string;
    isHidePurchaseDetails?: boolean;
    isCheckout?: boolean;
}): Promise<{ data: IGetMerchandiseVariantsApiResponseData }> =>
    callApi({
        url: listing_apis.get_merchandise_variants,
        method: CALL_API_METHODS.GET,
        params: {
            listing_uuid: listingUuid,
            ...(isHidePurchaseDetails && {
                is_hide_purchase_details: Boolean(isHidePurchaseDetails),
            }),
            is_checkout: Boolean(isCheckout),
        },
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    });
